"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
// import React from 'react';
const react_use_1 = require("react-use");
const hooks_1 = require("./");
exports.useOsmosysLocalCache = (namespace, key, initial, raw = false, workspaceSpecific = true) => {
    const appContext = hooks_1.useOsmosysContext();
    return react_use_1.useLocalStorage(`osmosys:wsm-${workspaceSpecific
        ? lodash_1.get(appContext, 'currentUser.currentWorkspaceMembership.id', '-no-wsm')
        : '-global'}:${namespace}`, initial, raw);
};
//# sourceMappingURL=useOsmosysLocalCache.js.map